import { useState } from 'react';

import PartnerDashboard from '../custom/PartnerDashboard'
export default function PartnerPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="PartnerPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <PartnerDashboard/>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
